const { TRM_BASE_ROUTE } = require('../../constants/trmConstants');

if (
  process.env.NODE_ENV === 'development' &&
  window.location.pathname.startsWith(TRM_BASE_ROUTE)
) {
  const mimic = require('mimic').default;
  const mocks = require.context(__dirname, true, /\.json$/);
  mocks.keys().forEach((key) => mimic.import(JSON.stringify(mocks(key))));
}
